import type { ShowNotification } from "@toolpad/core";
import { useNotifications } from "@toolpad/core";

const APP_NOTIFICATION_KEY_PREFIX = "app-notification";

let notificationSequence = 0;

export function useAppNotifications() {
  const notifications = useNotifications();

  const show: ShowNotification = (message, options) => {
    const key =
      options?.key ??
      `${APP_NOTIFICATION_KEY_PREFIX}-${String(++notificationSequence)}`;

    return notifications.show(message, {
      ...options,
      key,
    });
  };

  return {
    close: notifications.close,
    show,
  };
}
